import React from 'react'

import { ApiSearchInput } from './ApiSearchInput'
import { PrimeTableCustomFilterSelect } from './PrimeTableFilterSelect'
import { PrimeTableCustomFilterSelection } from './PrimeTableFilterSelection'

type TFilterType = 'select' | 'date-range'

type TFilerSelectList = { label: string; value: string } | null
type TFilterValue = string | null
type TFilerDateRange = { from: string; to: string } | null

type TParamFilter = {
  value: TFilerDateRange | TFilterValue
  list: TFilerSelectList[] | null
  type: TFilterType
  name: string
  label?: string
}
export type TParamFilterDateRange = TParamFilter & {
  value: TFilerDateRange
  type: 'date-range'
}
export type TParamFilterSelect = TParamFilter & {
  value: TFilterValue
  type: 'select'
}

export type TParamFilterData = TParamFilterDateRange | TParamFilterSelect

type TProps = {
  hasApiSearch: boolean
  apiSearchInput?: string
  apiFilterArray?: TParamFilterData[]
}

export const PrimeTableCustomHeader = ({
  hasApiSearch,
  apiSearchInput,
  apiFilterArray,
}: TProps) => {
  return (
    <div className="flex justify-content-between p-3">
      <div>
        {hasApiSearch && <ApiSearchInput apiSearchInput={apiSearchInput} />}
        {!!apiFilterArray && (
          <PrimeTableCustomFilterSelection apiFilterArray={apiFilterArray} />
        )}
      </div>
      {!!apiFilterArray && (
        <PrimeTableCustomFilterSelect apiFilterArray={apiFilterArray} />
      )}
    </div>
  )
}
